<!-- 客户->客户或物流公司转账；物流公司->客户或物流公司转账-->
<template>
    <div v-loading="loading" class="builda-infoes">
        <el-form :rules="rules" :model="submitData" label-width="80px" ref="submitData">
            <el-form-item label="转出方">
                <el-input size="small" disabled="" v-model="CurrentData._EntpCusName" style="width: 100%"></el-input>
            </el-form-item>
            <!-- <el-form-item label="转入客户">
                <el-select
                    size="small"
                    v-model="toEntpCusId"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="querySearch"
                    v-select-scroll-more="searchLoad"
                    style="width: 100%"
                >
                    <el-option v-for="optionItem in cusOptions" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem.EntpCusId">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="转入物流">
                <el-select
                    size="small"
                    v-model="toEntpLogId"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="queryLogSearch"
                    v-select-scroll-more="searchLogLoad"
                    style="width: 100%"
                >
                    <el-option v-for="optionItem in logOptions" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem.EntpCusId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发生日期" prop="Date">
                <el-date-picker style="width: 100%" v-model="submitData.Date" size="small" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="转出金额" prop="TotalAmount">
                <el-input size="small" type="number" v-model="showAmount" :min="0" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input size="small" v-model="submitData.Remark" style="width: 100%" placeholder="不填则自动生成"></el-input>
            </el-form-item>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()">提交</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['CurrentData'],
    components: {},
    data() {
        return {
            loading: false,
            payWayList: [],
            showAmount: 0,
            toEntpCusId: '',
            toEntpLogId: '',
            submitData: {
                CollectionAmount: 0,
                ToEntpCusId: '',
                FromEntpCusId: '',
                Remark: '',
                Date: '',
                RecordId: ''
            },
            rules: {
                Date: [{ required: true, message: '该项必填', trigger: 'change' }]
            },
            tableData: [],
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            logOptions: [],
            logForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    mounted() {
        if (this.CurrentData && this.CurrentData._EntpCusId) {
            this.submitData.FromEntpCusId = this.CurrentData._EntpCusId;
            this.submitData.RecordId = this.CurrentData.RecordId;
            // this.submitData.CollectionAmount = this.CurrentData.TotalAmount;
            //this.showAmount = this.CurrentData.OrderType == 0 ? this.CurrentData.TotalAmount : -this.CurrentData.TotalAmount;

            this.showAmount =
                this.CurrentData.OrderType == 0
                    ? this.CurrentData.IsAgent
                        ? this.CurrentData.TotalAmount - this.CurrentData.AgentAmount - this.CurrentData.AlreadyPaid
                        : this.CurrentData.TotalAmount - this.CurrentData.AlreadyPaid
                    : -this.CurrentData.TotalAmount;

            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);

            this.submitData.Date = date1;
        }
    },
    methods: {
        cancel() {
            this.$emit('closeDialog');
        },
        submitForm() {
            let that = this;
            if (that.showAmount == 0) {
                that.$util.warningMsg('转账金额必须不为0');
                return;
            }
            if (that.submitData.FromEntpCusId == that.toEntpLogId) {
                that.$util.warningMsg('不可以转入同一物流');
                return;
            }
            if (that.toEntpCusId && that.toEntpLogId) {
                that.$util.warningMsg('转入客户与转入物流只能选其一');
                return;
            }
            if (!that.toEntpCusId && !that.toEntpLogId) {
                that.$util.warningMsg('转入客户与转入物流必须选其一');
                return;
            }
            that.submitData.CollectionAmount = that.showAmount;
            that.$confirm(that.IsEdit ? '您确定要转款吗？' : '您确认要提交转账吗？', '提示', {
                confirmButtonText: '确定转账',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    that.$refs['submitData'].validate(valid => {
                        if (valid) {
                            that.loading = true;
                            that.submitData.ToEntpCusId = that.toEntpCusId ? that.toEntpCusId : that.toEntpLogId;
                            that.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_H/TransReceivedRecords_V2',
                                    data: that.submitData,
                                    hideLoading: true
                                })
                                .then(res => {
                                    that.$util.successMsg('转账成功');
                                    that.submitData.CollectionAmount = 0;
                                    that.submitData.Remark = '';
                                    that.submitData.RecordId = '';
                                    that.toEntpCusId = '';
                                    that.submitData.ToEntpCusId = '';
                                    that.$emit('closeDialog', true, that.showAmount, that.toEntpLogId);
                                    that.toEntpLogId = '';
                                })
                                .catch(() => {})
                                .finally(() => {
                                    that.loading = false;
                                });
                        } else {
                            return false;
                        }
                    });
                })
                .catch(() => {});
        },
        async querySearch(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            let data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLoad() {
            this.cusForm.Page += 1;
            this.querySearch();
        },
        async queryLogSearch(key) {
            if (![undefined].includes(key)) {
                this.logForm.Page = 1;
                this.logForm.stopLoad = false;
                this.logForm.key = key;
                this.logOptions = [];
            }
            if (this.logForm.stopLoad) return;
            let data = await this.$util.searchLogistic(this.logForm.key, this.logForm.Page, this.logForm.Limit);
            if (data) {
                if (!data) return;
                this.logForm.stopLoad = data.length < this.logForm.Limit;
                this.logOptions = [...this.logOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLogLoad() {
            this.logForm.Page += 1;
            this.queryLogSearch();
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.builda-infoes {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 340px;
    height: auto;

    .dialog-footer {
        text-align: right;
    }
    .el-form-item {
        margin-bottom: 0;
    }
}
</style>
